export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_13-32cac5a24ab381c5121d5d5570ff120a.jpg";